import React from "react";
import PdfViewer from "../../PdfViewer";

const PolizaMgavilan2025Sw = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/251103-Poliza-de-Servicios_Switches.pdf`;
  /*const pdfUrl = "/pdf/251103-Poliza-de-Servicios_Switches.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Póliza 2025 Switches</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PolizaMgavilan2025Sw;
